//
// Generated class LegalEntityDocument
//

/// <reference path="LegalEntityDocument_ManagedObject.ts" />

class LegalEntityDocument extends LegalEntityDocument_ManagedObject
{

}
